import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CustomCursor() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const updateMousePosition = (e: MouseEvent) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY
      });
    };
    window.addEventListener('mousemove', updateMousePosition);
    return () => window.removeEventListener('mousemove', updateMousePosition);
  }, []);
  return <motion.div className="fixed top-0 left-0 w-6 h-6 pointer-events-none z-[9999] hidden md:flex items-center justify-center mix-blend-difference" animate={{
    x: mousePosition.x - 12,
    y: mousePosition.y - 12
  }} transition={{
    type: 'tween',
    ease: 'backOut',
    duration: 0.1
  }} data-id="element-33" data-mp="33pqk0te2j02p">
      <div className="relative w-full h-full flex items-center justify-center text-[#B5743C]" data-id="element-34" data-mp="1ed6e9hurgv8n">
        <div className="absolute w-full h-[1px] bg-current" data-id="element-35" data-mp="1jaoln3t4r2ej" />
        <div className="absolute h-full w-[1px] bg-current" data-id="element-36" data-mp="33o3rkjc3jk4a" />
      </div>
    </motion.div>;
}